let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("7mKaC")).then(() => parcelRequire('8QBWd'));